/* eslint-disable no-return-assign */
import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import {
  MatSelectionList,
  MatSelectionListChange
} from '@angular/material/list';
import { Router } from '@angular/router';
import {
  DialogSearchComponent,
  DialogSearchData
} from '@app/shared/components/dialog-search/dialog-search.component';
import {
  EntityService,
  ILabelValueSelect,
  TokenService
} from 'viggo-sistemas-core-web';
import { CpfCnpjPipe } from '../../../../pipes/cpfCnpj-pipe/cpfCnpj.pipe';
import { ListItemOptions } from '../../models/entity-params';
import { LabelValueItem } from '../../models/utils.model';
import { ViggoCoreSearchHeaderViewMode } from '../controls-view-type/controls-view-type.component';

export interface SELECT {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-search-header',
  templateUrl: './search-header.component.html',
  styleUrls: ['./search-header.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [CpfCnpjPipe]
})
export class AppSearchHeaderComponent
  implements OnInit, OnChanges, AfterViewInit {
  selectedValue: string;
  selectedValue2: string;
  selectedValue3: string;
  maxDate = new Date();

  @ViewChild(MatSelectionList) protected matSelectionList: MatSelectionList;

  public checkAutoCompleteSecond = new UntypedFormControl();
  public keywordAutoComplete = new UntypedFormControl();
  public keywordAutoCompleteSecond = new UntypedFormControl();
  public keywordFormInput1 = new UntypedFormControl();
  public keywordFormInput2 = new UntypedFormControl();
  public keywordFormInput3 = new UntypedFormControl();
  public keywordFormInput4 = new UntypedFormControl();
  public keywordFormInput5 = new UntypedFormControl();
  public keywordFormDate1 = new UntypedFormControl();
  public keywordFormDate2 = new UntypedFormControl();
  public keywordFormDateRange = new UntypedFormControl();
  public keywordFormDateRangeStart = new UntypedFormControl();
  public keywordFormDateRangeEnd = new UntypedFormControl();
  public keywordCpf_Cnpj = new UntypedFormControl();
  public keywordSelect1 = new UntypedFormControl();
  public keywordSelect2 = new UntypedFormControl();
  public keywordSelect3 = new UntypedFormControl();

  public statusForm: UntypedFormControl;

  @Input() routerUrl: string;

  @Input() showReturnAct: boolean = false;

  @Input() useHeightLimited = false;

  @Input() onlyUpperCase = false;

  @Input() prefixTemplateViewMode: TemplateRef<Component>;

  @Input() suffixTemplateViewMode: TemplateRef<Component>;

  @Input() styleFields = '';

  @Input() dialogData = {} as DialogSearchData;

  @Input() showDialogAction = false;

  @Input() hiddenFilter = false;

  @Input() readOnlyInput = false;

  @Input() entityServiceAutocomplete: EntityService<any>;

  @Input() displayField = 'id';

  @Input() displaySecondField = 'id';

  @Input() searchFieldPathAutoComplete;

  @Input() valueSearchFieldAutoComplete = false;

  @Input() includeAutoComplete;

  @Input() domainPathAutoComplete = 'domain_id';

  @Input() insertTypeAutoComplete;

  @Input() displayFunctionAutocomplete = (entity: any | string) => {
    if (!entity) return '';
    if (typeof entity === 'string') return entity;
    return entity[this.displayField];
  };

  @Input() showAutoComplete = false;

  @Input() classAutoComplete = 'field w-column col-6 md:col-12';

  @Input() entityServiceAutocompleteSecond: EntityService<any>;

  @Input() displayFieldSecond = 'id';

  @Input() displaySecondFieldSecond = 'id';

  @Input() searchFieldPathAutoCompleteSecond;

  @Input() valueSearchFieldAutoCompleteSecond = false;

  @Input() includeAutoCompleteSecond;

  @Input() domainPathAutoCompleteSecond = 'domain_id';

  @Input() insertTypeAutoCompleteSecond;

  @Input() displayFunctionAutocompleteSecond = (entity: any | string) => {
    if (!entity) return '';
    if (typeof entity === 'string') return entity;
    return entity[this.displayFieldSecond];
  };

  @Input() showAutoCompleteSecond = false;

  @Input() classAutoCompleteSecond = 'field w-column col-6 md:col-12';

  // TEXTO
  @Input() showInput = false;

  @Input() classInputText1 = 'field w-column col-3 md:col-12';

  @Input() showInput2 = false;

  @Input() classInputText2 = 'field w-column col-3 md:col-12';

  @Input() showInput3 = false;

  @Input() classInputText3 = 'field w-column col-3 md:col-12';

  // NUMERICOS
  @Input() showInput4 = false;
  @Input() classInputText4 = 'field w-column col-4 md:col-12';

  @Input() showInput5 = false;
  @Input() classInputText5 = 'field w-column col-4 md:col-12';

  // DATA
  @Input() showInputDate1 = false;

  @Input() classInputDate1 =
    'field datePicker flex align-items-center w-column col-4 md:col-12';

  @Input() showInputDate2 = false;

  @Input() classInputDate2 =
    'field datePicker flex align-items-center w-column col-4 md:col-12';

  @Input() showInputDateRange = false;

  @Input() classInputDateRange =
    'field datePicker flex align-items-center w-column col-4 md:col-12';

  @Input() showInputCpfCnpj = false;

  @Input() classInputTextCpfCnpj = 'field w-column col-3 md:col-12';

  @Input() showInputSelect1 = false;

  @Input() classInputSelect1 = 'field w-column col-3 md:col-12';

  @Input() showInputSelect2 = false;

  @Input() classInputSelect2 = 'field w-column col-3 md:col-12';

  @Input() showInputSelect3 = false;

  @Input() classInputSelect3 = 'field w-column col-3 md:col-12';

  @Input() placeHolderAutoComplete: string;

  @Input() placeHolderAutoCompleteSecond: string;

  @Input() placeHolder1: string;

  @Input() placeHolder2: string;

  @Input() placeHolder3: string;

  @Input() placeHolder4: string;

  @Input() placeHolder5: string;

  @Input() placeHolderCpfCnpj: string;

  @Input() labelInputDate1: string;

  @Input() labelInputDate2: string;

  @Input() placeHolderSelect1: string;

  @Input() placeHolderSelect2: string;

  @Input() placeHolderSelect3: string;

  @Input() showSearchButton = true;

  @Input() showDownloadButton = true;

  @Input() showReloadButton = true;

  @Input() showInfoButton = true;

  @Input() selectOptions1: SELECT[] = [];

  @Input() selectOptions2: SELECT[] = [];

  @Input() selectOptions3: SELECT[] = [];

  @Input() typeInput1: string = 'text';

  @Input() typeInput2: string = 'text';

  @Input() typeInput3: string = 'text';

  @Input() typeInput4: string = 'text';

  @Input() typeInput5: string = 'text';

  @Input() showCheckBoxNotVendedor: boolean;

  @Input() entityStatusList: Array<LabelValueItem<ListItemOptions>> = [
    { label: 'Apenas ativos', value: 'ACTIVE_ONLY' },
    { label: 'Apenas inativos', value: 'INACTIVE_ONLY' },
    { label: 'Listar todos', value: 'ACTIVE_AND_INACTIVE' }
  ];

  @Input() filtersChipsApplied = [];

  @Input() useSearchChips = false;

  @Input() useListFilters = false;

  @Input() filterOptionsChips: ILabelValueSelect[];

  @Output() onFiltersChipsApplied = new EventEmitter<any>();

  @Output() onSearchChipFilter = new EventEmitter<any>();

  @Output() onClearChipFilter = new EventEmitter<any>();

  @Output() onChangeStatus: EventEmitter<ListItemOptions> = new EventEmitter<
    ListItemOptions
  >();

  @Output() public readonly onChangeSearchInput = new EventEmitter<string>();

  @Output() public onFilterStateAutoComplete = new EventEmitter<any>();

  @Output() public onFilterStateCheckAutoComplete = new EventEmitter<any>();

  @Output() public onFilterStateAutoCompleteSecond = new EventEmitter<any>();

  @Output() public onFilterStateInput1 = new EventEmitter<any>();

  @Output() public onFilterStateInput2 = new EventEmitter<any>();

  @Output() public onFilterStateInput3 = new EventEmitter<any>();

  @Output() public onFilterStateInput4 = new EventEmitter<any>();

  @Output() public onFilterStateInput5 = new EventEmitter<any>();

  @Output() public onClearInput1 = new EventEmitter<any>();

  @Output() public onClearInput2 = new EventEmitter<any>();

  @Output() public onClearInput3 = new EventEmitter<any>();

  @Output() public onClearInput4 = new EventEmitter<any>();

  @Output() public onClearInput5 = new EventEmitter<any>();

  @Output() public onClearSelect1 = new EventEmitter<any>();

  @Output() public onClearSelect2 = new EventEmitter<any>();

  @Output() public onClearSelect3 = new EventEmitter<any>();

  @Output() public onClearDate1 = new EventEmitter<any>();

  @Output() public onClearDate2 = new EventEmitter<any>();

  @Output() public onClearDateRange = new EventEmitter<any>();

  @Output() public onClearFilterAutocomplete = new EventEmitter<any>();

  @Output() public onClearFilterAutocomplete2 = new EventEmitter<any>();

  @Output() public onFilterStateDate1 = new EventEmitter<any>();

  @Output() public onFilterStateDate2 = new EventEmitter<any>();

  @Output() public onFilterStateDateRangeStart = new EventEmitter<any>();

  @Output() public onFilterStateDateRangeEnd = new EventEmitter<any>();

  @Output() public onFilterStateCpfCnpj = new EventEmitter<any>();

  @Output() public onClearInputCpfCnpj = new EventEmitter<any>();

  @Output() public onFilterStateSelect1 = new EventEmitter<any>();

  @Output() public onFilterStateSelect2 = new EventEmitter<any>();

  @Output() public onFilterStateSelect3 = new EventEmitter<any>();

  @Output() public onDialogResult = new EventEmitter<any>();

  @Output() public readonly onReloadClick = new EventEmitter<void>();

  @Output() public readonly onSearchClick = new EventEmitter<boolean>();

  @Output() public readonly onClearKeyboard = new EventEmitter<void>();

  @Output() public readonly onChangePreviewType = new EventEmitter<string>();

  @Output() public readonly onChangeInfoClik = new EventEmitter<void>();

  @Output() public readonly onDownloadDataClik = new EventEmitter<void>();

  @Input() showLoadingBar = false;

  @Input() initialValueStatus: ListItemOptions;

  @Input() multipleInputs = false;

  showClearFilters = false;

  /**
   * Variáveis responsáveis por identificar qual o dispositivo
   */
  public mobileOnly = false;
  public desktopOnly = false;

  // TODO: CASO FOR USAR O DIALOG DE PESQUISA ESSA FUNÇÃO APLICA O RESULTADO DO DIALOG
  // NO CAMPO DE FILTRO, PORÉM POR SER GENÉRICO É NECESSAŔIO APLICAR UMA FLAG Q INFORMA
  // SE ISSO SERÁ USADO OU NÃO
  // storage = (event): void => {
  //   this.keywordFormInput1.setValue(localStorage.getItem('resultFilter'))
  // };

  // ngOnDestroy() {
  //   window.removeEventListener('mouseover', this.storage, true);
  // }

  public ngOnInit() {
    // window.addEventListener('mouseover', this.storage, true);
    // localStorage.removeItem('resultFilter')
    var ua = navigator.userAgent;
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(
        ua
      )
    ) {
      this.mobileOnly = true;
      this.desktopOnly = false;
    } else {
      this.mobileOnly = false;
      this.desktopOnly = true;
    }
    this.statusForm = new UntypedFormControl();

    this.keywordFormDateRange.valueChanges.subscribe(value => {
      if (value) {
        if (value[0]) this.keywordFormDateRangeStart.setValue(value[0]);
        if (value[1]) {
          this.keywordFormDateRangeEnd.setValue(value[1]);
          this.onSearch();
        }
      }
    });

    this.keywordAutoCompleteSecond.valueChanges.subscribe(value => {
      if (value) {
        this.checkAutoCompleteSecond.disable();
      } else {
        this.checkAutoCompleteSecond.enable();
      }
    });

    this.checkAutoCompleteSecond.valueChanges.subscribe(value => {
      if (
        this.showCheckBoxNotVendedor &&
        (this.keywordAutoCompleteSecond.value === null ||
          this.keywordAutoCompleteSecond.value === '')
      ) {
        this.onSearch();
      }
    });

    this.keywordSelect1.valueChanges.subscribe(value => {
      if (value) this.onSearch();
    });
    this.keywordSelect2.valueChanges.subscribe(value => {
      if (value) this.onSearch();
    });
    this.keywordSelect3.valueChanges.subscribe(value => {
      if (value) this.onSearch();
    });
  }

  public disableFilter() {
    if (this.useSearchChips) {
      return this.filtersChipsApplied.length === 0;
    }
    return (
      (typeof this.keywordAutoComplete.value !== 'object' ||
        this.keywordAutoComplete.value === null) &&
      (typeof this.keywordAutoCompleteSecond.value !== 'object' ||
        this.keywordAutoCompleteSecond.value === null) &&
      (this.keywordFormInput1.value === '' ||
        this.keywordFormInput1.value === null) &&
      (this.keywordFormInput2.value === '' ||
        this.keywordFormInput2.value === null) &&
      (this.keywordFormInput3.value === '' ||
        this.keywordFormInput3.value === null) &&
      (this.keywordFormInput4.value === '' ||
        this.keywordFormInput4.value === null) &&
      (this.keywordFormInput5.value === '' ||
        this.keywordFormInput5.value === null) &&
      (this.keywordFormDate1.value === '' ||
        this.keywordFormDate1.value === null) &&
      (this.keywordFormDate2.value === '' ||
        this.keywordFormDate2.value === null) &&
      (this.keywordFormDateRangeStart.value === '' ||
        this.keywordFormDateRangeEnd.value === null) &&
      (this.keywordCpf_Cnpj.value === '' ||
        this.keywordCpf_Cnpj.value === null) &&
      !this.selectedValue &&
      !this.selectedValue2 &&
      !this.selectedValue3 &&
      (!this.statusForm.value || !this.statusForm.value[0])
    );
  }

  enterSearch(event) {
    if (event.key === 'Enter') {
      this.onSearch();
    }
  }

  public ngOnChanges(): void {
    if (this.tokenService.isLoggedIn()) {
      if (this.showLoadingBar)
        this.keywordAutoComplete.disable({ emitEvent: false });
      else this.keywordAutoComplete.enable({ emitEvent: false });
      if (!this.showCheckBoxNotVendedor) {
        if (this.showLoadingBar)
          this.keywordAutoCompleteSecond.disable({ emitEvent: false });
        else this.keywordAutoCompleteSecond.enable({ emitEvent: false });
      }

      if (this.showLoadingBar)
        this.keywordFormInput1.disable({ emitEvent: false });
      else this.keywordFormInput1.enable({ emitEvent: false });

      if (this.showLoadingBar)
        this.keywordFormInput2.disable({ emitEvent: false });
      else this.keywordFormInput2.enable({ emitEvent: false });

      if (this.showLoadingBar)
        this.keywordFormInput3.disable({ emitEvent: false });
      else this.keywordFormInput3.enable({ emitEvent: false });

      if (this.showLoadingBar)
        this.keywordFormInput4.disable({ emitEvent: false });
      else this.keywordFormInput4.enable({ emitEvent: false });

      if (this.showLoadingBar)
        this.keywordFormInput5.disable({ emitEvent: false });
      else this.keywordFormInput5.enable({ emitEvent: false });

      if (this.showLoadingBar)
        this.keywordFormDate1.disable({ emitEvent: false });
      else this.keywordFormDate1.enable({ emitEvent: false });

      if (this.showLoadingBar)
        this.keywordFormDate2.disable({ emitEvent: false });
      else this.keywordFormDate2.enable({ emitEvent: false });

      if (this.showLoadingBar)
        this.keywordFormDateRangeStart.disable({ emitEvent: false });
      else this.keywordFormDateRangeStart.enable({ emitEvent: false });

      if (this.showLoadingBar)
        this.keywordFormDateRangeEnd.disable({ emitEvent: false });
      else this.keywordFormDateRangeEnd.enable({ emitEvent: false });

      if (this.showLoadingBar)
        this.keywordCpf_Cnpj.disable({ emitEvent: false });
      else this.keywordCpf_Cnpj.enable({ emitEvent: false });

      if (this.showLoadingBar)
        this.keywordSelect1.disable({ emitEvent: false });
      else this.keywordSelect1.enable({ emitEvent: false });

      if (this.showLoadingBar)
        this.keywordSelect2.disable({ emitEvent: false });
      else this.keywordSelect2.enable({ emitEvent: false });

      if (this.showLoadingBar)
        this.keywordSelect3.disable({ emitEvent: false });
      else this.keywordSelect3.enable({ emitEvent: false });
    }
  }

  constructor(
    // public clienteService: ClienteService,
    // public fornecedorService: FornecedorService,
    protected cpfCnpjPipe: CpfCnpjPipe,
    protected dialog: MatDialog,
    protected router: Router,
    protected tokenService: TokenService
  ) {}

  public ngAfterViewInit(): void {
    setTimeout(() => {
      this.statusForm.setValue([this.initialValueStatus]);

      this.matSelectionList.selectionChange.subscribe(
        (s: MatSelectionListChange) => {
          this.matSelectionList.deselectAll();
          s.options.forEach(o => (o.selected = true));
          this.onChangeStatus.emit(this.statusForm.value);
        }
      );
    }, 1);
  }

  clearFilter1() {
    this.keywordFormInput1.setValue('');
    this.onClearInput1.emit(true);
  }

  clearFilter2() {
    this.keywordFormInput2.setValue('');
    this.onClearInput2.emit(true);
  }

  clearFilter3() {
    this.keywordFormInput3.setValue('');
    this.onClearInput3.emit(true);
  }

  clearFilter4() {
    this.keywordFormInput4.setValue('');
    this.onClearInput4.emit(true);
  }

  clearFilter5() {
    this.keywordFormInput5.setValue('');
    this.onClearInput5.emit(true);
  }

  clearFilterSelect1() {
    this.keywordSelect1.setValue('');
    this.onClearSelect1.emit(true);
  }

  clearFilterSelect2() {
    this.keywordSelect2.setValue('');
    this.onClearSelect2.emit(true);
  }

  clearFilterSelect3() {
    this.keywordSelect3.setValue('');
    this.onClearSelect3.emit(true);
  }

  clearFilterCpfCnpj() {
    this.keywordCpf_Cnpj.setValue('');
    this.onClearInputCpfCnpj.emit(true);
  }

  clearFilterDate1() {
    this.keywordFormDate1.setValue('');
    this.onClearDate1.emit(true);
  }

  clearFilterDate2() {
    this.keywordFormDate2.setValue('');
    this.onClearDate2.emit(true);
  }

  clearFilterDateRange() {
    this.keywordFormDateRange.setValue('');
    this.keywordFormDateRangeStart.setValue('');
    this.keywordFormDateRangeEnd.setValue('');
    this.onClearDateRange.emit(true);
  }
  clearFilterAutoComplete() {
    this.keywordAutoComplete.reset();
    this.onClearFilterAutocomplete.emit(true);
  }

  clearFilterAutoComplete2() {
    this.keywordAutoCompleteSecond.reset();
    this.onClearFilterAutocomplete2.emit(true);
  }

  public onClearKeyword(): void {
    if (!this.useSearchChips) {
      this.keywordAutoComplete.reset();
      this.keywordAutoCompleteSecond.reset();
      this.keywordFormInput1.reset();
      this.keywordFormInput2.reset();
      this.keywordFormInput3.reset();
      this.keywordFormInput4.reset();
      this.keywordFormInput5.reset();
      this.keywordFormDate1.reset();
      this.keywordFormDate2.reset();
      this.keywordFormDateRange.reset();
      this.keywordFormDateRangeStart.reset();
      this.keywordFormDateRangeEnd.reset();
      this.keywordCpf_Cnpj.reset();
      this.keywordSelect1.reset();
      this.keywordSelect2.reset();
      this.keywordSelect3.reset();
      this.statusForm.reset();
      this.checkAutoCompleteSecond.reset();
    }
    localStorage.removeItem('resultFilter');
    this.onFiltersChipsApplied.emit(this.filtersChipsApplied);
    this.filtersChipsApplied = [];
    this.onClearKeyboard.emit();
    this.onReloadClick.emit();
  }

  public changePreviewType(type: ViggoCoreSearchHeaderViewMode): void {
    this.onChangePreviewType.emit(type);
  }

  public openDialog() {
    this.dialog
      .open(DialogSearchComponent, {
        data: { dialogData: this.dialogData },
        panelClass: ['transparent-dialog']
      })
      .afterClosed()
      .subscribe(value => this.onDialogResult.emit(value));
  }

  public onSearch(): void {
    if (this.keywordCpf_Cnpj.value || this.keywordCpf_Cnpj.value === '')
      this.onFilterStateCpfCnpj.emit(this.keywordCpf_Cnpj.value);
    if (this.keywordFormInput1.value || this.keywordFormInput1.value === '')
      this.onFilterStateInput1.emit(this.keywordFormInput1.value);
    if (this.keywordFormInput2.value || this.keywordFormInput2.value === '')
      this.onFilterStateInput2.emit(this.keywordFormInput2.value);
    if (this.keywordFormInput3.value || this.keywordFormInput3.value === '')
      this.onFilterStateInput3.emit(this.keywordFormInput3.value);
    if (this.keywordFormInput4.value || this.keywordFormInput4.value === '')
      this.onFilterStateInput4.emit(this.keywordFormInput4.value);
    if (this.keywordFormInput5.value || this.keywordFormInput5.value === '')
      this.onFilterStateInput5.emit(this.keywordFormInput5.value);
    if (this.keywordFormDate1.value || this.keywordFormDate1.value === '')
      this.onFilterStateDate1.emit(this.keywordFormDate1.value);
    if (this.keywordFormDate2.value || this.keywordFormDate2.value === '')
      this.onFilterStateDate2.emit(this.keywordFormDate2.value);

    if (
      this.keywordFormDateRangeStart.value &&
      this.keywordFormDateRangeEnd.value
    ) {
      this.onFilterStateDateRangeStart.emit(
        this.keywordFormDateRangeStart.value
      );
      this.onFilterStateDateRangeEnd.emit(this.keywordFormDateRangeEnd.value);
    }

    if (this.keywordSelect1.value)
      this.onFilterStateSelect1.emit(this.keywordSelect1.value.value);
    if (this.keywordSelect2.value)
      this.onFilterStateSelect2.emit(this.keywordSelect2.value.value);
    if (this.keywordSelect3.value)
      this.onFilterStateSelect3.emit(this.keywordSelect3.value.value);

    if (this.keywordAutoComplete.value !== null)
      this.onFilterStateAutoComplete.emit(this.keywordAutoComplete.value);
    if (this.keywordAutoCompleteSecond.value !== null)
      this.onFilterStateAutoCompleteSecond.emit(
        this.keywordAutoCompleteSecond.value
      );

    if (
      (this.checkAutoCompleteSecond.value ||
        !this.checkAutoCompleteSecond.value) &&
      !this.keywordAutoCompleteSecond.value
    )
      this.onFilterStateCheckAutoComplete.emit(
        this.checkAutoCompleteSecond.value
      );

    this.onSearchClick.emit(true);
  }

  // parceiroDisplay = (entity: ICliente): string => {
  //   if (entity) {
  //     return entity.parceiro !== undefined
  //       ? this.cpfCnpjPipe.transform(entity.parceiro.cpf_cnpj) +
  //           ' - ' +
  //           entity.parceiro.nome_razao_social
  //       : '';
  //   }
  //   return '';
  // };

  validateOnlyNumbers(event, typeInput: string) {
    if (typeInput === 'number') {
      if (
        !/^\d+$/.test(event.key) &&
        !event.ctrlKey &&
        event.key !== 'Backspace' &&
        event.key !== 'Delete' &&
        event.key !== 'Tab' &&
        event.key !== 'ArrowLeft' &&
        event.key !== 'ArrowRight'
      )
        return false;
    }
    return true;
  }
}
